import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { COMPANY, mailLink, telLink } from "../lib/company";
import { useT } from "../lib/i18n";

export const Footer = () => {
  const { footer: f } = useT();
  return (
  <footer className="bg-[var(--ink)] text-[var(--bone)] pt-16 md:pt-24 pb-8 overflow-hidden" data-testid="footer">
    <div className="max-w-[1400px] mx-auto px-5 md:px-10">
      <div className="grid md:grid-cols-12 gap-10 pb-12 border-b border-white/15">
        <div className="md:col-span-5">
          <Logo light />
          <p className="mt-6 max-w-sm text-zinc-300 text-sm leading-relaxed">{f.desc}</p>
        </div>
        <div className="md:col-span-4 text-sm text-zinc-300 space-y-1.5">
          <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-zinc-400 mb-3">{f.company}</p>
          <p className="text-white font-semibold">{COMPANY.name}</p>
          <p>{f.seat}: {COMPANY.address} - {COMPANY.city}</p>
          <p>P.IVA {COMPANY.piva} · C.F. {COMPANY.cf}</p>
          <p>REA {COMPANY.rea}</p>
        </div>
        <div className="md:col-span-3 text-sm text-zinc-300 space-y-1.5">
          <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-zinc-400 mb-3">{f.contacts}</p>
          <a href={telLink} className="block hover:text-white" data-testid="footer-phone-link">{COMPANY.phoneDisplay}</a>
          <a href={mailLink()} className="block hover:text-white" data-testid="footer-email-link">{COMPANY.email}</a>
        </div>
      </div>
      <p className="font-display font-bold tracking-[-0.05em] leading-none text-[22vw] md:text-[18vw] text-white/[0.06] select-none -mb-[3vw] mt-6" aria-hidden>YOUCARS</p>
      <div className="flex flex-col sm:flex-row justify-between gap-3 text-xs text-zinc-400 pt-6 border-t border-white/15">
        <p>© {new Date().getFullYear()} {COMPANY.name} — P.IVA {COMPANY.piva}</p>
        <Link to="/admin" className="hover:text-white" data-testid="footer-admin-link">{f.admin}</Link>
      </div>
    </div>
  </footer>
  );
};
